import { render, staticRenderFns } from "./BottomCharts.vue?vue&type=template&id=0c22a26d&scoped=true"
import script from "./BottomCharts.vue?vue&type=script&lang=js"
export * from "./BottomCharts.vue?vue&type=script&lang=js"
import style0 from "./BottomCharts.vue?vue&type=style&index=0&id=0c22a26d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c22a26d",
  null
  
)

export default component.exports